// Do not edit this file, it is auto-generated at build time!
import * as AboutFacultyPage from '../components/pages/AboutFacultyPage';
import * as CartPage from '../components/pages/CartPage';
import * as CertificatesPage from '../components/pages/CertificatesPage';
import * as CheckoutPage from '../components/pages/CheckoutPage';
import * as CollectionProduct from '../components/pages/CollectionProduct';
import * as CreditClassPage from '../components/pages/CreditClassPage';
import * as CreditFormatPage from '../components/pages/CreditFormatPage';
import * as CreditInfoRiverPage from '../components/pages/CreditInfoRiverPage';
import * as CreditInfoTypePage from '../components/pages/CreditInfoTypePage';
import * as CreditTrackerAdminPage from '../components/pages/CreditTrackerAdminPage';
import * as CreditTrackerPage from '../components/pages/CreditTrackerPage';
import * as DebugPage from '../components/pages/DebugPage';
import * as ErrorPage from '../components/pages/ErrorPage';
import * as FacultyMember from '../components/pages/FacultyMember';
import * as GenericPage from '../components/pages/GenericPage';
import * as IndustryNode from '../components/pages/IndustryNode';
import * as IntendedAudienceNode from '../components/pages/IntendedAudienceNode';
import * as JurisdictionCreditInfoPage from '../components/pages/JurisdictionCreditInfoPage';
import * as LibraryPage from '../components/pages/LibraryPage';
import * as LicensesPage from '../components/pages/LicensesPage';
import * as MobileStoreRedirectPage from '../components/pages/MobileStoreRedirectPage';
import * as OperationalSearchResultPage from '../components/pages/OperationalSearchResultPage';
import * as OrderConfirmationPage from '../components/pages/OrderConfirmationPage';
import * as PodcastPage from '../components/pages/PodcastPage';
import * as PracticeAreaPage from '../components/pages/PracticeAreaPage';
import * as PressReleaseDetailPage from '../components/pages/PressReleaseDetailPage';
import * as ProfileSettingsPage from '../components/pages/ProfileSettingsPage';
import * as RuleChangesPage from '../components/pages/RuleChangesPage';
import * as SearchPage from '../components/pages/SearchPage';
import * as StandardHeadlessPage from '../components/pages/StandardHeadlessPage';
import * as StartPage from '../components/pages/StartPage';
import * as SubjectNode from '../components/pages/SubjectNode';
import * as PodcastSeriesNode from '../components/pages/catalog/PodcastSeriesNode';
import * as AnswerBookSingleTitleSubscriptionVariation from '../components/pages/catalog/variations/AnswerBookSingleTitleSubscriptionVariation';
import * as AnswerBookVariation from '../components/pages/catalog/variations/AnswerBookVariation';
import * as CourseHandbookSingleTitleSubscriptionVariation from '../components/pages/catalog/variations/CourseHandbookSingleTitleSubscriptionVariation';
import * as CourseHandbookVariation from '../components/pages/catalog/variations/CourseHandbookVariation';
import * as IndividualMembershipVariation from '../components/pages/catalog/variations/IndividualMembershipVariation';
import * as IndividualPlusSubscriptionVariation from '../components/pages/catalog/variations/IndividualPlusSubscriptionVariation';
import * as LiveProgramGroupcastVariation from '../components/pages/catalog/variations/LiveProgramGroupcastVariation';
import * as LiveProgramInteractiveWebcastVariation from '../components/pages/catalog/variations/LiveProgramInteractiveWebcastVariation';
import * as LiveProgramOhbVariation from '../components/pages/catalog/variations/LiveProgramOhbVariation';
import * as LiveProgramPbrSeminarVariation from '../components/pages/catalog/variations/LiveProgramPbrSeminarVariation';
import * as LiveProgramPBRWebcastVariation from '../components/pages/catalog/variations/LiveProgramPBRWebcastVariation';
import * as LiveProgramSeminarVariation from '../components/pages/catalog/variations/LiveProgramSeminarVariation';
import * as LiveProgramWebcastVariation from '../components/pages/catalog/variations/LiveProgramWebcastVariation';
import * as OnDemandInteractiveVariation from '../components/pages/catalog/variations/OnDemandInteractiveVariation';
import * as OnDemandMp3Variation from '../components/pages/catalog/variations/OnDemandMp3Variation';
import * as OnDemandMp4Variation from '../components/pages/catalog/variations/OnDemandMp4Variation';
import * as OnDemandOhbMp3Variation from '../components/pages/catalog/variations/OnDemandOhbMp3Variation';
import * as OnDemandOhbMp4Variation from '../components/pages/catalog/variations/OnDemandOhbMp4Variation';
import * as OnDemandOhbWebVariation from '../components/pages/catalog/variations/OnDemandOhbWebVariation';
import * as OnDemandPbrWebVariation from '../components/pages/catalog/variations/OnDemandPbrWebVariation';
import * as OnDemandWebVariation from '../components/pages/catalog/variations/OnDemandWebVariation';
import * as PodcastEpisodeVariation from '../components/pages/catalog/variations/PodcastEpisodeVariation';
import * as TreatiseSingleTitleSubscriptionVariation from '../components/pages/catalog/variations/TreatiseSingleTitleSubscriptionVariation';
import * as TreatiseVariation from '../components/pages/catalog/variations/TreatiseVariation';

const pages = new Map();

pages.set('AboutFacultyPage', AboutFacultyPage);
pages.set('CartPage', CartPage);
pages.set('CertificatesPage', CertificatesPage);
pages.set('CheckoutPage', CheckoutPage);
pages.set('CollectionProduct', CollectionProduct);
pages.set('CreditClassPage', CreditClassPage);
pages.set('CreditFormatPage', CreditFormatPage);
pages.set('CreditInfoRiverPage', CreditInfoRiverPage);
pages.set('CreditInfoTypePage', CreditInfoTypePage);
pages.set('CreditTrackerAdminPage', CreditTrackerAdminPage);
pages.set('CreditTrackerPage', CreditTrackerPage);
pages.set('DebugPage', DebugPage);
pages.set('ErrorPage', ErrorPage);
pages.set('FacultyMember', FacultyMember);
pages.set('GenericPage', GenericPage);
pages.set('IndustryNode', IndustryNode);
pages.set('IntendedAudienceNode', IntendedAudienceNode);
pages.set('JurisdictionCreditInfoPage', JurisdictionCreditInfoPage);
pages.set('LibraryPage', LibraryPage);
pages.set('LicensesPage', LicensesPage);
pages.set('MobileStoreRedirectPage', MobileStoreRedirectPage);
pages.set('OperationalSearchResultPage', OperationalSearchResultPage);
pages.set('OrderConfirmationPage', OrderConfirmationPage);
pages.set('PodcastPage', PodcastPage);
pages.set('PracticeAreaPage', PracticeAreaPage);
pages.set('PressReleaseDetailPage', PressReleaseDetailPage);
pages.set('ProfileSettingsPage', ProfileSettingsPage);
pages.set('RuleChangesPage', RuleChangesPage);
pages.set('SearchPage', SearchPage);
pages.set('StandardHeadlessPage', StandardHeadlessPage);
pages.set('StartPage', StartPage);
pages.set('SubjectNode', SubjectNode);
pages.set('PodcastSeriesNode', PodcastSeriesNode);
pages.set('AnswerBookSingleTitleSubscriptionVariation', AnswerBookSingleTitleSubscriptionVariation);
pages.set('AnswerBookVariation', AnswerBookVariation);
pages.set(
  'CourseHandbookSingleTitleSubscriptionVariation',
  CourseHandbookSingleTitleSubscriptionVariation
);
pages.set('CourseHandbookVariation', CourseHandbookVariation);
pages.set('IndividualMembershipVariation', IndividualMembershipVariation);
pages.set('IndividualPlusSubscriptionVariation', IndividualPlusSubscriptionVariation);
pages.set('LiveProgramGroupcastVariation', LiveProgramGroupcastVariation);
pages.set('LiveProgramInteractiveWebcastVariation', LiveProgramInteractiveWebcastVariation);
pages.set('LiveProgramOhbVariation', LiveProgramOhbVariation);
pages.set('LiveProgramPbrSeminarVariation', LiveProgramPbrSeminarVariation);
pages.set('LiveProgramPBRWebcastVariation', LiveProgramPBRWebcastVariation);
pages.set('LiveProgramSeminarVariation', LiveProgramSeminarVariation);
pages.set('LiveProgramWebcastVariation', LiveProgramWebcastVariation);
pages.set('OnDemandInteractiveVariation', OnDemandInteractiveVariation);
pages.set('OnDemandMp3Variation', OnDemandMp3Variation);
pages.set('OnDemandMp4Variation', OnDemandMp4Variation);
pages.set('OnDemandOhbMp3Variation', OnDemandOhbMp3Variation);
pages.set('OnDemandOhbMp4Variation', OnDemandOhbMp4Variation);
pages.set('OnDemandOhbWebVariation', OnDemandOhbWebVariation);
pages.set('OnDemandPbrWebVariation', OnDemandPbrWebVariation);
pages.set('OnDemandWebVariation', OnDemandWebVariation);
pages.set('PodcastEpisodeVariation', PodcastEpisodeVariation);
pages.set('TreatiseSingleTitleSubscriptionVariation', TreatiseSingleTitleSubscriptionVariation);
pages.set('TreatiseVariation', TreatiseVariation);

export function pageFactory(pageName: string) {
  const page = pages.get(pageName);

  return page?.Default || page?.default || page;
}
